<template>
<div class="grid">	
<div class="col-8">

<template v-if="thecertificate.upload_status">
<h4 class="text-green-600">{{certificatetype.name}} <i class="pi pi-check ml-2" style="font-size: 1.2em"></i></h4>	
</template>
<template v-else>
<h4 class="text-purple-600">{{certificatetype.name}}</h4>	
</template>


</div>


<div class="col-4">

<div class="flex align-items-center justify-content-end mt-3">

 <Button :label="$store.state.languages.lang_phrases.yeni_ekle" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" @click="showUploader" v-if="!show_uploader"></Button>

  <Button :label="$store.state.languages.lang_phrases.iptal" class=" p-button-danger p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" @click="hideUploader" v-if="show_uploader"></Button>

</div>
</div>




<template v-if="show_uploader">
<div class="col-12 md:col-6">
<FileUpload name="cover_image[]"  @select="onFilesAdded"  @remove="onFilesAdded"   v-model="item.files" :multiple="true" :showUploadButton="false" :showCancelButton="false" chooseLabel="Dosya Seçin"    :maxFileSize="10000000000" class="certificate_uploader" >
  <template #empty>
      <div class="certificate_uploader_empty uploader_empty">
      <span class="material-icons-outlined md-48 mr-2">backup
    </span>
      <p>Dosyaları buraya sürükleyip bırakın</p>
    </div>
  </template>
</FileUpload>
</div>



<div class="col-12 md:col-6 ">

<div class="col-12 ">
<span class="p-float-label mb-4 mt-0" >
 <InputText   v-model="item.certification_body" :id="'certification_body'+certificatetype.id" class="w-full p-inputtext-sm"  />
  <label :for="'certification_body'+certificatetype.id"  >{{$store.state.languages.lang_phrases.sertifika_tedarikcisi}}</label>
</span>
</div>



<div class="col-12 ">
<span class="p-float-label mb-4 mt-0" >
<Calendar v-model="item.valid_through"   :id="'valid_through'+certificatetype.id"  :showButtonBar="true" class="w-full p-inputtext-sm" :touchUI="true"  autocomplete="off"/>
 <label :for="'valid_through'+certificatetype.id"  >{{$store.state.languages.lang_phrases.gecerlilik_suresi}}</label>
</span>
</div>

<div class="col-12 " v-if="item.certification_body && item.valid_through && item.files.length">
<div class="flex align-items-center justify-content-end ">
 <Button :label="$store.state.languages.lang_phrases.kaydet" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" @click="submitFile"></Button>
</div>
</div>

</div>	
</template>





<template v-if="thecertificate.documents.length">
<div class="col-12 ">
<DataTable :value="thecertificate.documents" responsiveLayout="scroll">
    <Column field="certification_body" :header="$store.state.languages.lang_phrases.sertifika_tedarikcisi"></Column>
	<Column field="valid_through" :header="$store.state.languages.lang_phrases.gecerlilik_suresi">
	    <template #body="slotProps">
	         <p class="my-3">{{ $filters.momentFormat(slotProps.data.valid_through," Do-MM-YYYY ")}}</p>
	    </template>
	</Column>

	<Column field="status" :header="$store.state.languages.lang_phrases.durum">
	    <template #body="slotProps">
	    	<Tag 
	    	v-if="slotProps.data.status=='uploaded'"
			class="mr-2 mt-1 custom-chip"  
			:value="this.$store.state.languages.lang_phrases.degerlendirmede" 
			style="background-color:#3b82f6"
			/>

			<Tag 
	    	v-if="slotProps.data.status=='rejected'"
			class="mr-2 mt-1 custom-chip"  
			:value="this.$store.state.languages.lang_phrases.gecersiz" 
			style="background-color:#a82400"
			/>

			<Tag 
	    	v-if="slotProps.data.status=='accepted'"
			class="mr-2 mt-1 custom-chip"  
			:value="this.$store.state.languages.lang_phrases.gecerli" 
			style="background-color:#4dc247"
			/>	       
	    </template>
	</Column>

	<Column field="rejection_note" :header="$store.state.languages.lang_phrases.red_sebebi" headerStyle="width: 12rem">
	    <template #body="slotProps">
	        {{slotProps.data.rejection_note}}
	    </template>
	</Column>

	<Column field="filepath" :header="$store.state.languages.lang_phrases.yuklenen_dosyalar">
	    <template #body="slotProps">
	        <a :href="apihook+slotProps.data.filepath" target="_blank"><i class="pi pi-eye" style="font-size: 1.6em"></i></a>
	    </template>
	</Column>



</DataTable>

</div>
</template>
<template v-else>
	<div class="col-12 ">
	<h4 class="text-center text-primary my-4 py-4 color_bg">Henüz yüklü belge bulunmuyor</h4>
	</div>
</template>




<div class="col-12"><hr></div>







</div>
</template>

<script>
export default {

  name: 'SupplierCertificateUploader',
  props:["certificatetype","thecertificate"],
  data () {
    return {
    	item:{
    		certification_body:null,
    		valid_through:null,
    		certificatetype_id:null,    
    		files:[],		
    	},
    	show_uploader:false,
    }
  },
  computed:{
  	apihook()
  	{
  		let api =  process.env.VUE_APP_API_HOOK
  		api = api.replace("/api/","/")
  		//return api
  		return "https://storage.googleapis.com/verifycloud/"
  	},
  },
  methods:{
  	showUploader()
  	{
  		this.show_uploader = true
  	},
  	hideUploader()
  	{
  		this.show_uploader = false
  	},
  	onFilesAdded(event)
    {
      this.item.files = []
      for(let file of event.files)
      {
        this.item.files.push(file)
      }
    },
    submitFile()
    {

    	this.item.certificatetype_id = this.certificatetype.id    	
    	console.log(this.item)
    	this.$emit("fileReadyToUpload",this.item)
    	this.show_uploader = false
    },

  },
}
</script>

<style lang="css" scoped>
.certificate_uploader_empty{
	min-height: 100px;
}
.color_bg{
	background-color: rgba(50,50,50,0.15);
}
</style>